import { withAlpha } from "@/lib/color";
// AUTO-ESTRATTO da TeamDetail.jsx (refactor strutturale Fase 10.01) — nessun cambio di logica/UI/testid.
import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PlayerAvatar from "@/components/PlayerAvatar";
import { flagUrl } from "@/lib/flag";
import { trPositionShort } from "@/lib/pesTranslations";
import { positionToColor, vgColor, ListingBadge, LoanBadge, formatMln, renewEligibility, buybackReason, rosterStyleLabel } from "./helpers";
import { LegacyWageEditor, AdminRosterEditor } from "./admin";
import { RenewModal } from "./modals";

export function Cell({ label, value, valueNode, color = "rgb(var(--tc-ffffff))", big = false }) {
    return (
        <div>
            <div className="op-label text-[9px]">{label}</div>
            <div
                className={(big ? "op-mono font-bold text-base" : "op-mono text-sm") + " mt-0.5 leading-tight"}
                style={{ color }}
            >
                {valueNode != null ? valueNode : value}
            </div>
        </div>
    );
}

export function PlayerRow({ p, showLoanedTo, canMakeOffer = false, onMakeOffer, isAdmin = false, onResolveLoan, teamId, onLegacyWageSaved, canRenew = false, onRenewed, marketOpen = false, buyerTeamId = null, currentSeason = null, canListVetrina = false, canRequestUpdate = false, pendingUpdates = {}, onRequested }) {
    const [showRenew, setShowRenew] = useState(false);
    const positionColor = positionToColor(p.position);
    const noPes = !p.has_pes_id || p.pesdb_missing === true;
    const noPesReason = !p.has_pes_id ? "Mai sincronizzato con PES DB" : "Non più presente su PESDB (Authentic)";

    // Quante colonne ha la riga dati (per il colSpan della barra azioni sottostante)
    const colCount = 9 + (showLoanedTo ? 1 : 0) + (canMakeOffer ? 1 : 0) + (isAdmin && onResolveLoan ? 1 : 0);
    const canManage = canRenew && p.entry_id && !p.is_loaned_out && !p.is_on_loan;
    // Lo spostamento negli Agri (primavera) è consentito anche per i prestiti RICEVUTI
    // (secco/diritto/obbligo), non solo per i giocatori di proprietà. Restano esclusi
    // solo quelli DATI in prestito (is_loaned_out) e gli Ugly.
    const canDemote = canRenew && p.entry_id && !p.is_loaned_out && !p.is_ugly;
    // La PROMOZIONE è consentita anche per gli Ugly PRESI in prestito (is_on_loan):
    // salgono in prima squadra restando in prestito. Esclusi solo quelli DATI (is_loaned_out).
    const canPromote = canRenew && p.entry_id && p.is_ugly && !p.is_loaned_out;
    const renew = canManage ? renewEligibility(p) : null;
    const showActions =
        canManage ||
        canDemote ||
        canPromote ||
        (canListVetrina && p.entry_id && !p.is_loaned_out && !p.is_on_loan) ||
        (canRequestUpdate && p.entry_id) ||
        (isAdmin && !p.is_away_loan);

    return (
        <>
        <tr className={`hover:bg-t1a1d24/40 transition-colors ${showActions ? "" : "border-b border-t1a1d24"}`}>
            <td className="py-2 px-3">
                <span className="op-mono text-xs font-bold px-2 py-1 rounded-sm" style={{ background: withAlpha(positionColor, "22"), color: positionColor }}>
                    {trPositionShort(p.position) || "—"}
                </span>
            </td>
            <td className="py-2 px-3">
                <div className="flex items-center gap-2.5">
                    <PlayerAvatar
                        tmImage={p.tm_image}
                        pesImage={p.pes_image_url}
                        name={p.name}
                        size={32}
                    />
                    <div className="min-w-0 max-w-[280px]">
                        {(p.pes_id ?? p.entry_id) ? (
                            <Link to={`/giocatori/${p.pes_id ?? p.entry_id}`} className="text-tffffff hover:text-t2bb6ff transition-colors block truncate">
                                {p.name || `#${p.legacy_player_id}`}
                            </Link>
                        ) : (
                            <span className="text-tffffff block truncate" title="Nessun PES DB ID — solo Transfermarkt">
                                {p.name || `#${p.legacy_player_id}`}
                            </span>
                        )}
                        <div className="flex flex-wrap items-center gap-1.5 gap-y-1 max-w-[280px]">
                            {p.nationality && flagUrl(p.nationality) ? (
                                <img
                                    src={flagUrl(p.nationality)}
                                    alt={p.nationality}
                                    title={p.nationality}
                                    className="h-2.5 w-auto inline-block opacity-90"
                                    loading="lazy"
                                />
                            ) : p.nationality ? (
                                <span className="op-mono text-[10px] text-t8f95a3">{p.nationality}</span>
                            ) : null}
                            {(() => { const st = rosterStyleLabel(p); return st ? (
                                <span className="op-mono text-[10px] text-t8f95a3 truncate" title={st}>
                                    {st}
                                </span>
                            ) : null; })()}
                            {noPes && (
                                <span className="op-mono text-[9px] text-tff6b00 border border-tff6b00/40 px-1 py-0 rounded-sm uppercase" title={noPesReason}>
                                    no PES
                                </span>
                            )}
                            <ListingBadge type={p.listing_type} />
                            <LoanBadge p={p} />
                        </div>
                    </div>
                </div>
            </td>
            {showLoanedTo && (
                <td className="py-2 px-3 op-mono text-xs text-tc9ccd3">
                    {p.playing_team_name || "—"}
                    {p.loan_kind === "loan_option" && <span className="ml-1 text-[10px] text-tff9d2b">· diritto</span>}
                    {p.loan_kind === "loan" && <span className="ml-1 text-[10px] text-t8f95a3">· secco</span>}
                </td>
            )}
            <td className="py-2 px-3 text-center op-mono text-tc9ccd3">{p.age ?? "—"}</td>
            <td className="py-2 px-3 text-center op-mono font-bold" style={{ color: vgColor(p.vg) }}>
                {p.vg ?? "—"}
            </td>
            <td className="py-2 px-3 text-right op-mono text-tffffff hidden lg:table-cell">
                {p.tm_link ? (
                    <a
                        href={p.tm_link}
                        target="_blank"
                        rel="noreferrer noopener"
                        onClick={(e) => e.stopPropagation()}
                        className="hover:text-t2bb6ff transition-colors"
                        title={p.tm_value_date ? `Transfermarkt · Aggiornato al ${p.tm_value_date}` : "Apri su Transfermarkt"}
                    >
                        {formatMln(p.market_value)}
                    </a>
                ) : (
                    formatMln(p.market_value)
                )}
                {p.tm_value_date && (
                    <span className="block op-mono text-[9px] text-t5c6370 leading-none mt-0.5" title={`Valore Transfermarkt aggiornato al ${p.tm_value_date}`}>
                        agg. {p.tm_value_date}
                    </span>
                )}
            </td>
            {/* Legacy vs Nuovo — "Best of Two" (il MINIMO è VERDE). Se il contratto è
                stato RINNOVATO lo stipendio attivo è bloccato sul rinnovo e il Legacy
                resta solo come storico grigio (archivio). */}
            <td className="py-2 px-3 text-right op-mono"
                title={p.applied_wage_source === "legacy"
                    ? `🟢 Legacy (€${formatMln(p.current_wage)}) è inferiore alla formula nuova (€${formatMln(p.new_rule_wage)}). Stai pagando il LEGACY finché tieni il giocatore.`
                    : p.applied_wage_source === "renewed"
                        ? `📋 Legacy (€${formatMln(p.current_wage)}) storico, conservato come archivio. Lo stipendio attivo è quello del rinnovo (€${formatMln(p.applied_wage)}).`
                        : (p.current_wage > 0 ? `🟡 Legacy (€${formatMln(p.current_wage)}) era più alto: ora si applica la formula nuova.` : "Nessun contratto legacy importato")}>
                {(p.is_on_loan || p.is_away_loan) ? (
                    <span className="text-t5c6370">—</span>
                ) : (
                    <span style={{ color: p.applied_wage_source === "legacy" ? "rgb(var(--tc-10b981))" : "rgb(var(--tc-8f95a3))" }}>
                        <LegacyWageEditor
                            entryId={p.entry_id}
                            teamId={teamId}
                            currentWage={p.current_wage}
                            applied={p.applied_wage_source === "legacy"}
                            isAdmin={isAdmin}
                            onSaved={onLegacyWageSaved}
                        />
                    </span>
                )}
            </td>
            <td className="py-2 px-3 text-right op-mono font-semibold">
                {(p.is_on_loan || p.is_away_loan) ? (
                    <>
                        <div style={{ color: "rgb(var(--tc-10b981))" }} title="Quota stipendio a carico di questa squadra (in base allo split del prestito)">
                            {formatMln(p.loan_wage_charged)}
                        </div>
                        {p.loan_wage_note && (
                            <div className="text-[10px] text-tff9d2b font-normal">{p.loan_wage_note}</div>
                        )}
                    </>
                ) : (() => {
                    // Stipendio ATTIVO pagato ORA (= bilancio, best-of-two/rinnovo/contratto).
                    const mainWage = p.applied_wage;
                    // Proiezione: quanto diventerebbe se RINNOVI o VENDI ORA
                    // (formula nuova sul VG/overall attuale del sito). Solo indicativa.
                    const proj = p.new_rule_wage;
                    const showProj = proj != null && proj !== mainWage;
                    return (
                        <span style={{ color: "rgb(var(--tc-10b981))" }}
                            title={p.applied_wage_source === "renewed"
                                ? `🟢 Stipendio attivo bloccato dal rinnovo. Cambia solo a rinnovo/vendita.`
                                : p.applied_wage_source === "locked"
                                    ? `🟢 Stipendio attivo del contratto (acquisto/ingaggio). Cambia solo a rinnovo/vendita.`
                                    : p.applied_wage_source === "legacy"
                                        ? `🟢 Stipendio attivo = Legacy (€${formatMln(p.current_wage)}), più basso della formula nuova: è quello che paghi.`
                                        : `🟢 Stipendio attivo (formula nuova, regola C).`}>
                            <div data-testid="roster-active-wage">{formatMln(mainWage)}</div>
                            {p.applied_wage_source === "renewed" && (
                                <div className="text-[10px] text-t7ce38b font-normal" title="Stipendio bloccato dal rinnovo del contratto">(rinnovato)</div>
                            )}
                            {showProj && (
                                <div className="text-[10px] text-tff7a1a font-normal"
                                    title="Proiezione: stipendio se RINNOVI o VENDI il giocatore ORA (formula nuova sul VG attuale). Non è quello che paghi adesso."
                                    data-testid="roster-wage-projection">
                                    ({formatMln(proj)} se rinnovi/vendi)
                                </div>
                            )}
                        </span>
                    );
                })()}
            </td>
            <td className="py-2 px-3 text-center op-mono">{p.contract_years ?? "—"}</td>
            <td className="py-2 px-3">
                <div className="flex flex-wrap gap-1">
                    {(p.statuses || []).map((s, i) => (
                        <span key={i} className="op-mono text-[9px] px-1.5 py-0.5 border border-t22252a text-tc9ccd3 uppercase">
                            {s}
                        </span>
                    ))}
                </div>
            </td>
            {canMakeOffer && (
                <td className="py-2 px-3 text-right">
                    {p.entry_id && !p.is_loaned_out ? (() => {
                        const loanBlock = p.is_on_loan
                            ? "In prestito: non cedibile finché il riscatto non è risolto (fine stagione)"
                            : null;
                        const bbReason = loanBlock ? null : buybackReason(p, buyerTeamId, currentSeason);
                        return (
                            <button
                                className={`op-mono text-[10px] uppercase tracking-wider px-2 py-1 border transition-colors ${loanBlock ? "border-t3a3d44 text-t5c6370 cursor-not-allowed" : "border-t2bb6ff/40 text-t2bb6ff hover:bg-t2bb6ff/10"}`}
                                onClick={() => !loanBlock && onMakeOffer?.(p)}
                                disabled={!!loanBlock}
                                title={loanBlock || (bbReason ? `${bbReason} (puoi comunque fare un'offerta di PRESTITO)` : undefined)}
                                data-testid={`offer-btn-${p.entry_id}`}
                            >
                                {loanBlock ? "Bloccato" : "Offerta"}
                            </button>
                        );
                    })() : null}
                </td>
            )}
            {isAdmin && onResolveLoan && (
                <td className="py-2 px-3 text-right">
                    {p.entry_id && p.is_loaned_out && !p.is_away_loan ? (
                        <button
                            className="op-mono text-[10px] uppercase tracking-wider px-2 py-1 border border-tff6b00/50 text-tff6b00 hover:bg-tff6b00/10 transition-colors"
                            onClick={() => onResolveLoan?.(p)}
                            data-testid={`resolve-btn-${p.entry_id}`}
                        >
                            Risolvi
                        </button>
                    ) : null}
                </td>
            )}
        </tr>
        {showActions && (
            <tr className="border-b border-t1a1d24">
                <td colSpan={colCount} className="px-3 pt-0 pb-2.5">
                    <div className="flex flex-wrap items-center gap-1.5 pl-[42px]" data-testid={`row-actions-${p.entry_id}`}>
                        {canManage && (
                            <button
                                className={`op-mono text-[10px] uppercase tracking-wider px-2.5 py-1 border rounded-sm transition-colors ${renew.allowed ? "border-t7ce38b/40 text-t7ce38b hover:bg-t7ce38b/10" : "border-t3a3d44 text-t5c6370 cursor-not-allowed"}`}
                                onClick={() => renew.allowed && setShowRenew(true)}
                                disabled={!renew.allowed}
                                title={renew.reason}
                                data-testid={`renew-btn-${p.entry_id}`}
                            >
                                Rinnova
                            </button>
                        )}
                        {canManage && (
                            <ReleaseButton p={p} teamId={teamId} onReleased={onRenewed} compact marketOpen={marketOpen} currentSeason={currentSeason} />
                        )}
                        {canManage && p.is_ugly && (
                            <PromoteButton p={p} teamId={teamId} onPromoted={onRenewed} marketOpen={marketOpen} compact />
                        )}
                        {canPromote && !canManage && (
                            <PromoteButton p={p} teamId={teamId} onPromoted={onRenewed} marketOpen={marketOpen} compact />
                        )}
                        {canDemote && (
                            <DemoteButton p={p} teamId={teamId} onDemoted={onRenewed} marketOpen={marketOpen} compact />
                        )}
                        {canListVetrina && p.entry_id && !p.is_loaned_out && !p.is_on_loan && (
                            <VetrinaButton p={p} onChanged={onRenewed} compact />
                        )}
                        {canRequestUpdate && p.entry_id && (
                            <RequestUpdateButtons p={p} teamId={teamId} pendingKinds={pendingUpdates[p.entry_id] || []} onRequested={onRequested} compact />
                        )}
                        {isAdmin && !p.is_away_loan && (
                            <AdminRosterEditor p={p} teamId={teamId} isAdmin={isAdmin} onChanged={onRenewed} compact />
                        )}
                    </div>
                    {showRenew && (
                        <RenewModal player={p} teamId={teamId} onClose={() => setShowRenew(false)} onDone={() => { setShowRenew(false); onRenewed?.(); }} />
                    )}
                </td>
            </tr>
        )}
        </>
    );
}

export function RequestUpdateButtons({ p, teamId, pendingKinds = [], onRequested, compact = false }) {
    const [busy, setBusy] = useState("");
    const [err, setErr] = useState("");
    if (!p.entry_id) return null;

    const hasPes = !!(p.pes_id || p.has_pes_id);
    const hasTm = !!(p.tm_link || hasPes);
    const isPending = (k) => pendingKinds.includes(k);

    const request = async (kind) => {
        setBusy(kind); setErr("");
        try {
            await api.post(`/teams/${teamId}/roster/${p.entry_id}/request-update`, { kind });
            onRequested?.();
        } catch (e) {
            setErr(e.response?.data?.detail || "Errore");
        } finally { setBusy(""); }
    };

    const renderBtn = (kind, label, enabled, disabledReason) => {
        if (isPending(kind)) {
            return (
                <span
                    className="op-mono text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-sm border border-tffb020/40 text-tffb020 inline-block"
                    title="Richiesta inviata: in attesa che l'admin elabori l'aggiornamento"
                    data-testid={`update-pending-${kind}-${p.entry_id}`}
                >
                    {label} richiesto ⏳
                </span>
            );
        }
        return (
            <button
                className={`op-mono text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-sm border transition-colors ${enabled ? "border-t9d7cff/40 text-t9d7cff hover:bg-t9d7cff/10" : "border-t3a3d44 text-t5c6370 cursor-not-allowed"} disabled:opacity-60`}
                onClick={() => enabled && request(kind)}
                disabled={!enabled || busy === kind}
                title={enabled ? `Richiedi all'admin l'aggiornamento ${label} di questo giocatore` : disabledReason}
                data-testid={`request-update-${kind}-${p.entry_id}`}
            >
                {busy === kind ? "..." : `Richiedi agg. ${label}`}
            </button>
        );
    };

    return (
        <div className="flex flex-wrap items-center gap-1.5">
            {renderBtn("tm", "TM", hasTm, "Nessun link Transfermarkt")}
            {renderBtn("pesdb", "PESDB", hasPes, "Nessuna scheda PESDB agganciata")}
            {err && <div className="op-mono text-[9px] text-tff3b30 w-full">{err}</div>}
        </div>
    );
}

export function VetrinaButton({ p, onChanged, compact = false }) {
    const [open, setOpen] = useState(false);
    const [type, setType] = useState("sale");
    const [price, setPrice] = useState("");
    const [note, setNote] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    const listed = !!p.listing_type;

    const create = async () => {
        const ok = window.confirm(
            "Pubblicando questo giocatore in vetrina:\n" +
            "• resterà in vetrina per 15 giorni, poi esce da solo (puoi anche toglierlo prima)\n" +
            "• NON potrai modificare l'annuncio, solo toglierlo\n" +
            "• una volta uscito (tolto o scaduto) non potrai rimetterlo in vetrina per 15 giorni\n\n" +
            "Confermare la pubblicazione?"
        );
        if (!ok) return;
        setBusy(true); setErr("");
        try {
            await api.post("/market/listings", {
                entry_id: p.entry_id,
                listing_type: type,
                price_mln: parseFloat(price) || 0,
                note: note.trim() || null,
            });
            setOpen(false); setPrice(""); setNote("");
            onChanged?.();
        } catch (e) {
            setErr(e.response?.data?.detail || "Errore");
        } finally { setBusy(false); }
    };

    const remove = async () => {
        if (!p.listing_id) return;
        setBusy(true); setErr("");
        try {
            await api.delete(`/market/listings/${p.listing_id}`);
            onChanged?.();
        } catch (e) {
            setErr(e.response?.data?.detail || "Errore");
        } finally { setBusy(false); }
    };

    if (listed) {
        const typeLabel = p.listing_type === "loan" ? "Prestito" : "Vendita";
        const priceTxt = p.listing_price ? ` · ${formatMln(p.listing_price)}` : "";
        return (
            <div className={compact ? "inline-flex items-center gap-1.5" : ""}>
                <span className="op-mono text-[10px] text-t7ce38b" title="Annuncio attivo nel Mercato">🏷️ In vetrina ({typeLabel}{priceTxt})</span>
                <button
                    className={`op-mono text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-sm border border-tff3b30/40 text-tff3b30 hover:bg-tff3b30/10 transition-colors disabled:opacity-50 ${compact ? "" : "mt-1"}`}
                    onClick={remove}
                    disabled={busy}
                    data-testid={`vetrina-remove-${p.entry_id}`}
                >
                    {busy ? "..." : "Togli dalla vetrina"}
                </button>
                {err && <div className="op-mono text-[9px] text-tff3b30 mt-1">{err}</div>}
            </div>
        );
    }

    if (!open) {
        return (
            <button
                className={`op-mono text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-sm border border-t2bb6ff/40 text-t2bb6ff hover:bg-t2bb6ff/10 transition-colors`}
                onClick={() => setOpen(true)}
                data-testid={`vetrina-btn-${p.entry_id}`}
            >
                Metti in vetrina
            </button>
        );
    }

    return (
        <div className="mt-1 p-2 border border-t2bb6ff/30 bg-t0a0c0f space-y-2 w-full max-w-xs" data-testid={`vetrina-form-${p.entry_id}`}>
            <div className="flex gap-1">
                {[["sale", "Vendita"], ["loan", "Prestito"]].map(([v, label]) => (
                    <button
                        key={v}
                        onClick={() => setType(v)}
                        className={`op-mono text-[10px] uppercase px-2 py-0.5 border transition-colors ${type === v ? "border-t2bb6ff text-t2bb6ff bg-t2bb6ff/10" : "border-t22252a text-t8f95a3"}`}
                        data-testid={`vetrina-type-${v}-${p.entry_id}`}
                    >
                        {label}
                    </button>
                ))}
            </div>
            <input
                type="number" min="0" step="0.5"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder={type === "loan" ? "Costo prestito (mln, 0 = gratis)" : "Prezzo richiesto (mln)"}
                className="op-input w-full text-right text-xs"
                data-testid={`vetrina-price-${p.entry_id}`}
            />
            <input
                type="text" maxLength={200}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Nota (opzionale)"
                className="op-input w-full text-xs"
                data-testid={`vetrina-note-${p.entry_id}`}
            />
            {err && <div className="op-mono text-[9px] text-tff3b30">{err}</div>}
            <div className="flex gap-1">
                <button
                    onClick={create}
                    disabled={busy}
                    className="flex-1 op-mono text-[10px] uppercase tracking-wider py-1 border border-t7ce38b/40 text-t7ce38b hover:bg-t7ce38b/10 transition-colors disabled:opacity-50"
                    data-testid={`vetrina-confirm-${p.entry_id}`}
                >
                    {busy ? "..." : "Pubblica"}
                </button>
                <button
                    onClick={() => { setOpen(false); setErr(""); }}
                    disabled={busy}
                    className="op-mono text-[10px] uppercase tracking-wider px-2 py-1 border border-t22252a text-t8f95a3 hover:text-tffffff transition-colors"
                    data-testid={`vetrina-cancel-${p.entry_id}`}
                >
                    ✕
                </button>
            </div>
        </div>
    );
}


export function ReleaseButton({ p, teamId, onReleased, compact = false, marketOpen = false, currentSeason = null }) {
    const [busy, setBusy] = useState(false);
    const years = (p.contract_years && p.contract_years > 0) ? p.contract_years : 1;
    const penalty = Math.round(0.5 * (p.applied_wage || 0) * years);
    // Blocco stagionale: preso da svincolato/Agri in questa stagione (acquired_season
    // >= stagione corrente) oppure tag SVI ancora presente. Cade al cambio stagione.
    const acq = Number(p.acquired_season);
    const seasonalLocked = (Number.isFinite(acq) && currentSeason != null && Number(currentSeason) <= acq)
        || (p.statuses || []).includes("SVI") || (p.statuses || []).includes("SVI2");
    const marketClosed = !marketOpen;
    const locked = seasonalLocked || marketClosed;
    const warn = `Se lo svincoli paghi il 50% del contratto residuo (${formatMln(p.applied_wage)} × ${years} ${years === 1 ? "anno" : "anni"}) = penale ${formatMln(penalty)}, accreditata al Tesoro DOP.`;
    const seasonReason = "Preso da svincolato/Agri in questa stagione: potrai svincolarlo dalla prossima stagione. Per ora puoi solo venderlo o scambiarlo.";
    const closedReason = "Svincolo possibile solo a finestra di mercato aperta.";
    const lockReason = seasonalLocked ? seasonReason : closedReason;
    const label = busy ? "Svincolo…"
        : (seasonalLocked ? "Svincolo bloccato (stagione)"
            : (marketClosed ? "Svincolo bloccato (mercato chiuso)" : "Svincola"));
    const handle = async () => {
        if (busy) return;
        if (!window.confirm(`Svincolare ${p.name}?\n\n${warn}\n\nIl giocatore tornerà svincolato (disponibile per le aste). Confermi?`)) return;
        setBusy(true);
        try {
            const { data } = await api.post(`/teams/${teamId}/roster/${p.entry_id}/release`);
            window.alert(`${data.player_name} svincolato. Penale pagata: ${formatMln(data.penalty)}.`);
            onReleased?.();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore durante lo svincolo");
        } finally {
            setBusy(false);
        }
    };
    return (
        <button
            className={`${compact ? "op-mono text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-sm" : "w-full mt-2 op-mono text-xs uppercase tracking-wider py-2"} border transition-colors ${locked ? "border-t3a3d44 text-t5c6370 cursor-not-allowed" : "border-tff3b30/40 text-tff3b30 hover:bg-tff3b30/10"}`}
            onClick={locked ? undefined : handle}
            disabled={busy || locked}
            title={locked ? lockReason : warn}
            data-testid={`release-btn-${p.entry_id}`}
        >
            {label}
        </button>
    );
}

export function PromoteButton({ p, teamId, onPromoted, marketOpen = false, compact = false }) {
    const [busy, setBusy] = useState(false);
    const handle = async () => {
        if (busy || !marketOpen) return;
        if (!window.confirm(`Promuovere ${p.name} in prima squadra?\n\nDiventerà una faccia nuova (NFC) ed entrerà in Rosa principale. Da ora il suo stipendio entra nel monte ingaggi. Confermi?`)) return;
        setBusy(true);
        try {
            const { data } = await api.post(`/teams/${teamId}/roster/${p.entry_id}/promote`);
            window.alert(`${data.player_name} promosso in prima squadra.`);
            onPromoted?.();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore durante la promozione");
        } finally {
            setBusy(false);
        }
    };
    return (
        <button
            className={`${compact ? "op-mono text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-sm" : "w-full mt-2 op-mono text-xs uppercase tracking-wider py-2"} border transition-colors ${marketOpen ? "border-t7ce38b/40 text-t7ce38b hover:bg-t7ce38b/10" : "border-t3a3d44 text-t5c6370 cursor-not-allowed"}`}
            onClick={handle}
            disabled={busy || !marketOpen}
            title={marketOpen ? "Promuovi in prima squadra (faccia nuova)" : "Promozione possibile solo a mercato aperto"}
            data-testid={`promote-btn-${p.entry_id}`}
        >
            {busy ? "Promozione…" : (marketOpen ? "⬆ Promuovi" : "⬆ Promuovi (mercato chiuso)")}
        </button>
    );
}


// Inverso di Promuovi: sposta un titolare nel Settore Ugly ("primavera").
// Eleggibile solo se VG ≤ 78 ed età ≤ 21, e mai per i giocatori con status SVI.
export function DemoteButton({ p, teamId, onDemoted, marketOpen = false, compact = false }) {
    const [busy, setBusy] = useState(false);
    const isSvi = (p.statuses || []).includes("SVI") || (p.statuses || []).includes("SVI2");
    const eligible = p.vg != null && p.age != null && p.vg <= 78 && p.age <= 21 && !isSvi;
    if (!eligible) return null;
    const handle = async () => {
        if (busy || !marketOpen) return;
        if (!window.confirm(`Spostare ${p.name} in primavera (Settore Ugly)?\n\nUscirà dalla Rosa principale e diventerà un Ugly (perde l'eventuale tag NFC). Confermi?`)) return;
        setBusy(true);
        try {
            await api.post(`/teams/${teamId}/roster/${p.entry_id}/demote`);
            onDemoted?.();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore durante lo spostamento");
        } finally {
            setBusy(false);
        }
    };
    return (
        <button
            className={`${compact ? "op-mono text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-sm" : "w-full mt-2 op-mono text-xs uppercase tracking-wider py-2"} border transition-colors ${marketOpen ? "border-tff9d2b/40 text-tff9d2b hover:bg-tff9d2b/10" : "border-t3a3d44 text-t5c6370 cursor-not-allowed"}`}
            onClick={handle}
            disabled={busy || !marketOpen}
            title={marketOpen ? "Sposta nel Settore Ugly (primavera) · VG ≤ 78 e ≤ 21 anni" : "Spostamento possibile solo a mercato aperto"}
            data-testid={`demote-btn-${p.entry_id}`}
        >
            {busy ? "Spostamento…" : (marketOpen ? "⬇ Sposta in primavera" : "⬇ Primavera (mercato chiuso)")}
        </button>
    );
}


